import { createAction } from 'redux-actions';
// upload a file
export let uploadFile = createAction('UPLOAD_FILE', (fileid, bytes, chunksize)=>({
        fileid,
        bytes,
        chunksize
    }));
export let setUploadState = createAction('SET_UPLOAD_STATE', (fileid, state, data)=>({
        fileid,
        state,
        ...data
    }));
export let clearUploads = createAction('CLEAR_UPLOADS', ()=>{});
